// Action type constants for reducers
export const GET_CART = 'GET_CART';
export const ADD_TO_CART = 'ADD_TO_CART';
export const DELETE_FROM_CART = 'DELETE_FROM_CART';
export const CART_LOADING = 'CART_LOADING';
export const GET_ITEMS_CART = 'GET_ITEMS_CART';
export const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART';
export const DELETE_ITEM_FROM_CART = 'DELETE_ITEM_FROM_CART';
// Optimistic local removal of one line, ahead of the server's answer. Distinct
// from DELETE_ITEM_FROM_CART, which only clears the loading/error flags.
export const REMOVE_CART_LINE = 'REMOVE_CART_LINE';
export const CART_ITEM_LOADING = 'CART_ITEM_LOADING';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
